import React, { useContext } from 'react';
// Mui components
import { Box, Button, Typography } from '@mui/material';
// Components
import SmallModalContainer from '../../common/SmallModalContainer';
// Icons
import iconError from '../../../assets/icons/icon_circle-error.svg';
import { AgendaContext } from '../../../contexts/AgendaContext';

function ModalErrorExternoConectados({ openModal, onHandleClose }) {
    const { proveedorSeleccionado } = useContext(AgendaContext)
    return (
        <SmallModalContainer open={openModal}
            onClose={onHandleClose}>
            <Box display="flex" flexDirection="column" gap={"1rem"}>
                <Box
                    component="img"
                    sx={{ width: "54px", height: "54px" }}
                    alt="img not found"
                    src={iconError}
                />
                <Typography variant="h1">No encontramos consultorios disponibles</Typography>
                <Typography variant="h4" component="p">Tu consultorio publicado en {proveedorSeleccionado?.label} ya se encuentra conectado o con una solicitud en curso.</Typography>
                <Typography variant="h5" component="p">Verificalo y de no ser así, comunicate con nosotros.</Typography>
                <Box display="flex" gap={"1rem"} marginTop="1.5rem">
                    <Button
                        onClick={onHandleClose}
                        variant="contained"
                        sx={{ height: "48px", borderRadius: "16px", width: "100%" }}>
                        <Typography variant="cta" component="span">Entendido</Typography>
                    </Button>
                </Box>
            </Box>
        </SmallModalContainer>
    );
}

export default ModalErrorExternoConectados;